import { render, staticRenderFns } from "./ed-homework-feedback.vue?vue&type=template&id=79a97944&scoped=true&"
import script from "./ed-homework-feedback.ts?vue&type=script&lang=js&"
export * from "./ed-homework-feedback.ts?vue&type=script&lang=js&"
import style0 from "./ed-homework-feedback.scss?vue&type=style&index=0&id=79a97944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a97944",
  null
  
)

export default component.exports